MOVE.MORTGAGE.RATES.SORT = (function () {
  var options = [
    {label: 'Relevance', value: 'relevance'},
    {label: 'Monthly Payment', value: 'monthly-payment'},
    {label: 'APR', value: 'apr'},
    {label: 'Fees', value: 'fees'}
  ];

  var byType = function (rates, value) {
    var set;
    switch (value) {
    case 'relevance':
      // Order returned by API - no value to sort
      set = rates; break;
    case 'monthly-payment':
      set = _.sortBy(rates, function(rate) {
        return rate.loan_payment;
      }); break;
    case 'apr':
      set = _.sortBy(rates, function(rate) {
        return rate.apr_val;
      }); break;
    case 'fees':
      set = _.sortBy(rates, function(rate) {
        return parseInt(rate.loan_fees, 10);
      }); break;
    default:
      set = rates; break;
    }
    return set;
  };

  var homeEquityBaseSort = function(rates) {
    var isSponsored  = [];
    var notEditorial = [];
    var isEditorial  = [];
    for (var i = 0; i < rates.length; i++) {
      if (rates[i].IsSponsored) {
        isSponsored.push(rates[i]);
        continue;
      } else if (!rates[i].IsEditorial) {
        notEditorial.push(rates[i]);
        continue;
      } else if (rates[i].IsEditorial) {
        isEditorial.push(rates[i]);
        continue;
      }
    }
    return [isSponsored, notEditorial, isEditorial];
  }

  var flatten = function(arr) {
    return arr.reduce(
      (a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []
    );
  }

  var sortHomeEquityByType = function(rates, value) {
    var set;
    var groups = homeEquityBaseSort(rates);
    switch(value) {
      case 'relevance':
        set = flatten(groups);
        break;

      case 'loan-product':
        set = flatten(groups.map((group) => _.sortBy(group, (rate) => rate.LoanType === 'HELOAN'))); 
        break;

      case 'rate':
        set = flatten(groups.map((group) =>  
          _.sortBy(group, (rate) => { if (rate.Apr) return rate.Apr; })
        ));
        break;

      case 'estimate-payment':
        set = flatten(groups.map((group) => 
          _.sortBy(group, (rate) => { if (rate.LoanPayment) return rate.LoanPayment; })
        ));   
        break;

      case 'points':
        set = flatten(groups.map((group) => 
          _.sortBy(group, (rate) => { if (rate.Points) return rate.Points; })  
        ));        
        break;

      case 'advertiser-name':
        set = flatten(groups.map((group) => 
          _.sortBy(group, (rate) => { if (rate.Advertiser) return rate.Advertiser; })  
        )); 
        break;

      default:
        set = rates; 
        break;
      }
      return set;
    };

  MOVE.MORTGAGE.RATES.SORT = {
    options: options,
    byType: byType,
    sortHomeEquityByType
  };

  return MOVE.MORTGAGE.RATES.SORT;

})();



// WEBPACK FOOTER //
// ./mortgage/rates/sort.js